import React, { useEffect, useState } from "react";
import TextField from '@mui/material/TextField';
import { Autocomplete, Button, CircularProgress } from '@mui/material';
import MenuItem from '@mui/material/MenuItem';
import { useAuth } from "../../../../../auth/auth";
import { GetActiveProjects, getRateTypes } from "../../../../../api/apiCall";
import { Controller, useForm } from "react-hook-form";

type Props = {
  week: any
  onSubmit: any
  closeModal: any
  dateOfTheShift: any
  currentCell: any
  formDate: any
  loading: any
}

type FormValues = {
  week: 0
  projectId: string
  rowIndex: number
  columnIndex: number
  whatsAppName: string
  region: string
  jobDate: string
  location: string
  postCode: string
  jobDescription: string
  shiftType: number
  requiredWorkers: number
  startTime: any
  endTime: any
  rateTypeId: string
}

const AddShift = ({
  week,
  onSubmit,
  closeModal,
  dateOfTheShift,
  currentCell,
  formDate,
  loading
}: Props) => {
  const { state } = useAuth();
  const [projects, setProjects] = useState([]);
  const [selectedTypeOfWork, setSelectedTypeOfWork] = useState<string>("");
  const [rateTypes, setRateTypes] = useState<any[]>([]);
  const [selectedShiftType, setSelectedShiftType] = useState<number>(
    (currentCell.colIndex === 0 || currentCell.colIndex === 1) ? 2 : 0
  );

  const {
    register,
    handleSubmit,
    control,
    setValue,
    formState: { errors }
  } = useForm<FormValues>({
    defaultValues: {
      projectId: "",
      week: week,
      rowIndex: currentCell.rowIndex,
      columnIndex: currentCell.colIndex,
      location: "",
      region: selectedTypeOfWork,
      jobDate: formDate,
      shiftType: selectedShiftType,
      jobDescription: "",
      requiredWorkers: 1,
      postCode: "",
      whatsAppName: "",
      startTime: "00:00",
      endTime: "00:00",
      rateTypeId: ""
    }
  });

  const getAllProjects = async () => {
    const response = await GetActiveProjects(state.user?.token);
    setProjects(response);
  };

  const fetchRateTypes = async () => {
    try {
      const response = await getRateTypes(state.user?.token);

      if (response) {
        setRateTypes(response.data);
      }
    } catch (error) {
      console.error("Failed to fetch rate types:", error);
    }
  };

  const selectRateTypeByShiftType = (shiftType: number) => {
    const matchingRateType = rateTypes.find(
      (rateType: any) =>
        Number(rateType.shiftType) === Number(shiftType)
    );

    if (matchingRateType) {
      setValue("rateTypeId", matchingRateType.id);
    }
  };

  useEffect(() => {
    getAllProjects();
    fetchRateTypes();
  }, []);

  useEffect(() => {
    if (rateTypes.length > 0) {
      selectRateTypeByShiftType(selectedShiftType);
    }
  }, [rateTypes]);

  return (
    <form>
      <div className="center-content">

        <TextField
          label="Week"
          type="number"
          size="small"
          disabled
          {...register("week")}
          style={{ width: "20%", margin: 10 }}
        />

        <TextField
          label="WhatsApp Name"
          type="text"
          size="small"
          error={!!errors.whatsAppName}
          style={{ margin: 10, width: '30%' }}
          {...register("whatsAppName",{
            required: "Whats app Name is required"
          })}
        />

        <Controller
          name="projectId"
          control={control}
          rules={{ required: "Project is required" }}
          render={({ field }) => (
            <Autocomplete
              options={projects}
              getOptionLabel={(option: any) =>
                `${option?.company?.companyName} - ${option?.projectName}`
              }
              isOptionEqualToValue={(
                option: any,
                value: any
              ) =>
                option.id === value?.id
              }
              onChange={(_, value: any) =>
                field.onChange(value?.id || "")
              }
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Client-Project"
                  size="small"
                  error={!!errors.projectId}
                  helperText={errors.projectId?.message}
                  sx={{ width: "300px", margin: 1.2 }}
                />
              )}
            />
          )}
        />
      </div>
      <div className="center-content">
        <TextField
          select
          id="demo-select-small"
          size="small"
          label="Type of Work"
          value={selectedTypeOfWork}
          style={{ margin: 10, width: '22.5%' }}
          {...register("region")}
          onChange={(e) => setSelectedTypeOfWork(e.target.value)}
        >
          <MenuItem value={"N/A"}>N/A</MenuItem>
          <MenuItem value={'Price Work'}>Price Work</MenuItem>
          <MenuItem value={'Labour'}>Labour</MenuItem>
          <MenuItem value={'X Other'}>X Other</MenuItem>
        </TextField>
        <TextField
          label="Location"
          type="text"
          size="small"
          {...register("location")}
          error={!!errors.location}
          style={{width: "20%", margin: 10}}
        />

        <TextField
          label="Post Code"
          type="text"
          size="small"
          error={!!errors.postCode}
          {...register("postCode")}
          style={{width: "20%", margin: 10}}
        />

        <TextField
          label="Start Time"
          type="time"
          size="small"
          {...register("startTime")}
          onChange={(event: any) => {
            if(currentCell.colIndex === 0 || currentCell.colIndex === 1) {
              return;
            } else {
              const hour = parseInt(event.target.value.slice(0, 2), 10);
              const shiftType = hour >= 6 && hour < 18 ? 0 : 1;

              setValue('shiftType', shiftType)
              setSelectedShiftType(shiftType)

              selectRateTypeByShiftType(shiftType)
            }
          }}
          style={{ width: "15.5%", margin: 10 }}
        />

      </div>

      <div className="center-content">

        <TextField
          label="End Time"
          type="time"
          size="small"
          {...register("endTime")}
          style={{ width: "13.5%", margin: 10 }}
        />

        <TextField
          label="Date"
          id="outlined-basic"
          variant="outlined"
          type="text"
          value={dateOfTheShift}
          {...register("jobDate")}
          disabled
          size="small"
          style={{margin: 10, width: "16.5%"}}
        />

        <TextField
          label="Required Workers"
          type="number"
          {...register("requiredWorkers", {
            required: "Required Workers is required"
          })}
          onInput={(e: any) => {
            e.target.value = e.target.value.replace(/[^0-9]/g, '');
          }}
          error={!!errors.requiredWorkers}
          size="small"
          style={{ margin: 10, width: "13%" }}
        />
        <Controller
          name="rateTypeId"
          control={control}
          rules={{
            required: "Rate Type is required"
          }}
          render={({ field }) => (
            <TextField
              {...field}
              size="small"
              select
              label="Rate Type"
              error={!!errors.rateTypeId}
              helperText={errors.rateTypeId?.message}
              style={{
                height: 40,
                marginTop: 10,
                margin: 10,
                width: "16.5%"
              }}
            >
              {rateTypes.map((rateType: any) => (
                <MenuItem key={rateType.id} value={rateType.id}>
                  {rateType.name}
                </MenuItem>
              ))}
            </TextField>
          )}
        />
        <TextField
          select
          size="small"
          label="Shift Type"
          error={!!errors.shiftType}
          value={selectedShiftType}
          {...register("shiftType", {
              required: "Shift Type Workers is required"
          })}
          onChange={(e: any) => {
            const shiftType = Number(e.target.value);
    
            setSelectedShiftType(shiftType);
            setValue("shiftType", shiftType);
    
            selectRateTypeByShiftType(shiftType);
          }}
          style={{ height: 40, marginTop: 10, margin: 10, width: '16.5%' }}
      >
        <MenuItem value={0}>Day Shift</MenuItem>
        <MenuItem value={1}>Night Shift</MenuItem>
        <MenuItem value={2}>Weekend</MenuItem>
        <MenuItem value={3}>Holiday</MenuItem>
      </TextField>
      </div>

      <div className="center-content">

        <TextField
          multiline
          rows={4}
          error={!!errors.jobDescription}
          label="Description"
          {...register("jobDescription")}
          style={{ width: "84%", margin: 10 }}
        />

      </div>

      <div className="center-content margin40">

        <Button
          variant="outlined"
          id="save-button"
          size="large"
          disabled={loading}
          onClick={handleSubmit(onSubmit)}
        >
          {loading ? (
            <CircularProgress
              size={20}
              style={{
                color: "white"
              }}
            />
          ) : (
            "Save"
          )}
        </Button>

        <Button
          variant="outlined"
          onClick={closeModal}
          size="large"
          disabled={loading}
          style={{ width: "25%" }}
        >
          Cancel
        </Button>

      </div>
    </form>
  );
};

export default AddShift;
